// Sales
import Sales from '@/views/admin/Sales.vue'
import SDeclined from '@/views/admin/sales/Declined.vue'
import SAcccepted from '@/views/admin/sales/Accepted.vue'
import SPending from '@/views/admin/sales/Pending.vue'

const salesRoutes = {
  path: '/hrd12/hrd12/sales',
  component: Sales,
  redirect: '/hrd12/hrd12/sales/processed',
  name: 'Sales',
  meta: {
    title: 'Sales'
  },
  children: [
    {
      path: '/hrd12/hrd12/sales/declined',
      component: SDeclined,
      name: 'DeclinedSales',
      meta: {
        title: 'Declined Sales'
      }
    },
    {
      path: '/hrd12/hrd12/sales/processed',
      component: SAcccepted,
      name: 'AcceptedSales',
      meta: {
        title: 'Accepted Sales'
      }
    },
    {
      path: '/hrd12/hrd12/sales/pending',
      component: SPending,
      name: 'PendingSales',
      meta: {
        title: 'Pending Sales'
      }
    }
  ]
}

export default salesRoutes
